import React, { useEffect, useState } from 'react';
import { MainChat } from './mainChat/mainChat';
import { TableChat } from './tableChat/tableChat';
import { PrivateChat } from './privateChat/privateChat';
import { ReactComponent as PrivateImg } from './assets/private-img.svg';
import { ReactComponent as LobbyImg } from './assets/lobby-img.svg';
import { ReactComponent as TableImg } from './assets/table-img.svg';
import Tabs, { TabPane } from '@ui-kit/components/tabs';
import { container } from 'tsyringe';
import { MessagesService } from './messagesService';
import styles from './chat.module.scss';
import { t, useBehaviorSubject } from '@base/utils/helpers';
import { IPlayersOnlineRepository } from '../player/model/interfaces';

enum ChatTabs {
  LOBBY = 1,
  TABLE,
  PRIVATE,
}

export const Chat = () => {
  const messagesService: MessagesService = container.resolve('messagesService');
  const recipient = useBehaviorSubject(messagesService.onPrivateChatJoined);
  const playersOnlineRepository: IPlayersOnlineRepository = container.resolve('playersOnlineRepository');
  const [showPrivateMessages, setShowPrivateMessages] = useState(false);
  const [primaryActiveChat, setPrimaryActiveChat] = useState(ChatTabs.LOBBY);

  useEffect(() => {
    if (recipient) setPrimaryActiveChat(ChatTabs.PRIVATE);
    else if (playersOnlineRepository.me?.getTable()) setPrimaryActiveChat(ChatTabs.TABLE);
    else setPrimaryActiveChat(ChatTabs.LOBBY);
  }, [playersOnlineRepository, recipient]);

  function handlePrivateChat() {
    showPrivateMessages && setShowPrivateMessages(false);
    setPrimaryActiveChat(ChatTabs.PRIVATE);
  }

  return (
    <Tabs activeKey={primaryActiveChat} style={{ height: '100%' }}>
      <TabPane
        key={ChatTabs.LOBBY}
        label={t('lobby')}
        className={styles.tab}
        icon={<LobbyImg />}
        onClick={() => setPrimaryActiveChat(ChatTabs.LOBBY)}
      >
        <MainChat />
      </TabPane>
      {playersOnlineRepository.me?.getTable() ? (
        <TabPane
          key={ChatTabs.TABLE}
          className={styles.tab}
          label={t('table')}
          icon={<TableImg />}
          onClick={() => setPrimaryActiveChat(ChatTabs.TABLE)}
        >
          <TableChat />
        </TabPane>
      ) : null}
      {recipient && recipient.getPid() && recipient.getPid() >= 0 ? (
        <TabPane
          key={ChatTabs.PRIVATE}
          className={styles.tab}
          label={recipient.name}
          onClick={handlePrivateChat}
          icon={<PrivateImg onClick={() => messagesService.closePrivateChat()} />}
        >
          <PrivateChat recipientId={recipient.getPid()} />
        </TabPane>
      ) : null}
    </Tabs>
  );
};
